import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../styles/img/Logo.png';
import './AuthHeader.css';

const AuthHeader = () => {
  return (
    <div className="auth-header mb-4 text-center">
      <Link to="/" className="navbar-logo">
        <img src={logo} alt="SecurePaper" className="logo-image" />
        <span className="logo-text">Secure<span className="text-primary">Paper</span></span>
      </Link>
    </div>
  );
};

export default AuthHeader;
